const VITE_CMS_API_TOKEN = import.meta.env.VITE_CMS_API_TOKEN;
const CMS_BASE_URL = import.meta.env.VITE_CMS_BASEURL;

class VistaService {
  baseURL: string;
  headers: Record<string, string>;

  constructor() {
    this.baseURL = `${CMS_BASE_URL}/api`;
    this.headers = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${VITE_CMS_API_TOKEN}`,
    };
  }

  // Generic API call method
  async apiCall(endpoint, options = {}) {
    const response = await fetch(`${this.baseURL}${endpoint}`, {
      headers: this.headers,
      ...options,
    });

    if (!response.ok) {
      let errorMsg = response.statusText;
      try {
        const errorData = await response.json();
        if (errorData?.error?.message) {
          errorMsg = errorData.error.message;
        } else if (errorData?.message) {
          errorMsg = errorData.message;
        }
      } catch {
        // Fallback to statusText if body is not JSON
      }
      throw new Error(`API call failed: ${response.status} - ${errorMsg}`);
    }

    return await response.json();
  }

  async updateAwardSubmission(submissionId: string, submissionData: any) {
    return this.apiCall(`/award-submissions/${submissionId}`, {
      method: 'PUT',
      body: JSON.stringify({ data: submissionData }),
    });
  }
}

// Create and export a singleton instance
const vistaService = new VistaService();
export default vistaService;
